(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    (function() {
    const subject = document.getElementById('ContactForm-subject');
    if (!subject) return;

    const sections = {
      order: document.getElementById('ContactForm-order-fields'),
      company: document.getElementById('ContactForm-company-fields'),
      sample: document.getElementById('ContactForm-sample-fields')
    };

    const rules = {
      'Bestellung': ['order'],
      'Reklamation': ['order'],
      'Händleranfrage': ['company'],
      'Muster bestellen': ['sample']
    };

    function updateFields() {
      // Alle ausblenden und required entfernen
      Object.values(sections).forEach(function(el) {
        el.style.display = 'none';
        el.querySelectorAll('input').forEach(function(input) {
          input.removeAttribute('required');
        });
      });

      var active = rules[subject.value] || [];
      active.forEach(function(key) {
        var el = sections[key];
        el.style.display = 'block';
        // Required setzen (ausser bei optionalen Feldern)
        el.querySelectorAll('input').forEach(function(input) {
          if (input.placeholder.indexOf('optional') === -1) {
            input.setAttribute('required', '');
          }
        });
      });
    }

    subject.addEventListener('change', updateFields);
  })();
  } catch(e) { console.error(e); }
})();

})();
